import { Module } from 'vuex';
import type { AppState } from '../types';

export interface RewardState {
  /** 用户奖励金数量 */
  points: number;
  /** 奖励金可抵扣金额 */
  amount: number;
  /** 服务端返回的开关状态 */
  pointSwitch: boolean;
  /** 用户手动控制的开关状态（列表页） */
  userSwitch: boolean;
  /** 营销条是否展示 */
  isBarVisible: boolean;
  /** 详情页奖励金勾选项是否展示 */
  isRewardCheckboxVisible: boolean;
  /** 详情页用户是否勾选了奖励金 */
  rewardChecked: boolean;
  /** 详情页数据刷新标记（递增触发详情页重新请求） */
  detailRefreshFlag: number;
  /** 下单后刷新流程进行中标记（防止 mallList watch 在此期间触发列表重载导致浮层销毁） */
  isPostOrderRefreshing: boolean;
}

const reward: Module<RewardState, AppState> = {
  namespaced: true,
  state: {
    points: 0,
    amount: 0,
    pointSwitch: false,
    userSwitch: false,
    isBarVisible: false,
    isRewardCheckboxVisible: false,
    rewardChecked: false,
    detailRefreshFlag: 0,
    isPostOrderRefreshing: false,
  },
  mutations: {
    /** 设置用户奖励金数据（来自 mall.user.discount 接口） */
    setDiscountData(state, data: { points: number; amount: number; pointSwitch: boolean }) {
      // 安全降级：数据异常时使用默认值
      state.points = Number(data?.points) || 0;
      state.amount = Number(data?.amount) || 0;
      state.pointSwitch = !!data?.pointSwitch;
      // 用户开关状态与服务端保持同步：
      // - 服务端开启 且 用户未手动开启 → 跟随服务端开启
      // - 服务端关闭 → 强制关闭（服务端关闭可能是后台禁用、规则变更等，前端必须尊重）
      if (state.pointSwitch) {
        if (!state.userSwitch) {
          state.userSwitch = true;
        }
      } else {
        state.userSwitch = false;
      }
    },
    /** 设置用户手动开关状态（列表页） */
    setUserSwitch(state, val: boolean) {
      state.userSwitch = val;
    },
    /** 更新营销条可见性 */
    updateBarVisibility(state) {
      state.isBarVisible = state.points > 0;
      // 奖励金为 0 时重置开关状态，确保商品价格恢复原价
      if (!state.isBarVisible) {
        state.userSwitch = false;
      }
    },
    /** 设置详情页勾选项可见性 */
    setRewardCheckboxVisible(state, val: boolean) {
      state.isRewardCheckboxVisible = val;
    },
    /** 设置详情页勾选状态 */
    setRewardChecked(state, val: boolean) {
      state.rewardChecked = val;
    },
    /** 触发详情页数据刷新（递增计数器，详情页 watch 此值重新请求） */
    triggerDetailRefresh(state) {
      state.detailRefreshFlag += 1;
    },
    /**
     * 设置下单后刷新流程状态
     * 解决 mallList watch 在此期间触发列表重载导致浮层销毁，无法及时刷新详情浮层问题
     * @param val true: 刷新中（此时列表页应禁止刷新） false: 刷新结束
     */
    setPostOrderRefreshing(state, val: boolean) {
      state.isPostOrderRefreshing = val;
    },
  },
};

export default reward;
